import TestIds from 'constants/test-ids'
import Tooltip from '@ui-components-3/ui/lib/components/Tooltip'
import { useMemo } from 'react'
import InfoIcon from '@ui-components-3/icons/lib/solid/CircleInfo'

export type InfoTooltipProps = {
  tooltip: string | Record<string, string>
  id: number
}

const InfoTooltip = ({ tooltip, id }: InfoTooltipProps): JSX.Element => {
  const content = useMemo(
    () => (tooltip ? (typeof tooltip === 'string' ? [tooltip] : Object.values(tooltip)) : []).join('\n\n'),
    [tooltip],
  )

  return (
    <Tooltip variant="light" content={<p className="whitespace-pre-line">{content}</p>} placement="top">
      <div tabIndex={0} className="ml-1.5">
        <InfoIcon aria-label="Info" className="w-3 h-3 text-primary-800" data-testid={TestIds.common.tooltip.icon} />
      </div>
    </Tooltip>
  )
}

export default InfoTooltip
